import React from 'react';
import './RetroPrekidac.css';

/* Prekidač retro teme — stoji pored prekidača dan/noć (custom/TemaPrekidac.js)
   i ima isti oblik API-ja, pa oba mogu da se ređaju jedan do drugog bez
   posebnog rasporeda.

   Namerno NIJE ista pilula kao dan/noć: dan/noć je mekan i obao („komad neba"),
   a ovaj je tvrd i pravougaon — pikselski ekran sa crnim okvirom, rasterom
   linija i lampicom koja se upali. Razlika u obliku odmah kaže da ovo nije
   treća nijansa istog prekidača nego drugi izbor.

   Sve crta CSS; prazni <span>-ovi su nosači oblika. `onToggle(event)` dobija
   događaj, jer applyThemeWithReveal otkriva novu temu krugom iz tačke klika. */
const RetroPrekidac = ({ on, onToggle, ariaLabel, className = '' }) => (
    <button
        type="button"
        role="switch"
        aria-checked={on}
        aria-label={ariaLabel}
        className={`retro-toggle${on ? ' on' : ''}${className ? ` ${className}` : ''}`}
        onClick={onToggle}
    >
        {/* Ekran seče svoj sadržaj (raster, odsjaj), lampica i blok smeju preko. */}
        <span className="retro-ekran">
            <span className="retro-raster" />
            <span className="retro-odsjaj" />
        </span>
        <span className="retro-lampica" />
        <span className="retro-blok">
            <span className="retro-piksel retro-piksel-1" />
            <span className="retro-piksel retro-piksel-2" />
            <span className="retro-piksel retro-piksel-3" />
        </span>
    </button>
);

export default RetroPrekidac;
